import moment from 'moment'

export const useHelpers = (): {
    createArrayFromGivenRange(start: number, end: number): number[]
    removeAllNullOrEmptyProperties(obj: Record<string, unknown>): Record<string, unknown>
    formatDate(date: Date | string, format?: string): string
} => {
    /**
     * Create array of numbers from given range
     *
     * @param start
     * @param end
     */
    const createArrayFromGivenRange = (start: number, end: number): number[] => {
        const length = end - start + 1
        return Array.from({ length }, (_, i) => start + i)
    }

    /**
     * Remove all null properties from object
     *
     * @param obj
     */
    const removeAllNullOrEmptyProperties = (
        obj: Record<string, unknown>,
    ): Record<string, unknown> => {
        return Object.fromEntries(
            Object.entries(obj).filter(
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                ([_, v]) => (typeof v === 'string' ? v.length !== 0 : v != null),
            ),
        )
    }

    /**
     * Format date
     *
     * @param date
     * @param format
     * @returns formatedDate as string
     */
    const formatDate = (date: Date | string, format?: string): string =>
        moment(date).format(format || 'YYYY-MM-DD')

    return {
        createArrayFromGivenRange,
        removeAllNullOrEmptyProperties,
        formatDate,
    }
}
